module.exports = __webpack_public_path__ + "fonts/SuisseIntl-UltralightItalic.d288ad0.woff2";